/** @jsxImportSource theme-ui */

const boxShadow = 'inset 0 0 0 1000px rgba(0,0,0,.2)'

export const LayoutsListCard = ({ layout }) => {
  return (
    <article
      sx={{
        height: '576px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundImage: `url(${layout.image})`,
        backgroundSize: 'cover',
        boxShadow: boxShadow,
        '@media (hover: hover)': {
          boxShadow: 'inset 0 0 0 1000px rgba(0,0,0,.0)',
          ':hover': { boxShadow: boxShadow },
          transition: theme => `all ${theme.transitions.medium} ease-in`,
        },
      }}
    >
      {layout.title}
    </article>
  )
}
